import 'readmore-js'

$(window).on('load', () => {
  $('.js-readmore').readmore({
    speed: 185,
    moreLink: '<a href="#">Раскрыть</a>',
    lessLink: '<a href="#">Скрыть</a>',
    afterToggle: function(trigger, element, expanded) {
      element[0].classList.toggle('is-open')
    }
  })

  $('.js-category-readmore').readmore({
    speed: 185,
    collapsedHeight: 98,
    moreLink: '<a href="#">Раскрыть</a>',
    lessLink: '',
    afterToggle: function(trigger, element, expanded) {
      element[0].classList.toggle('is-open')
    }
  })
})
